import React, { useEffect } from 'react';

const Gallery = () => {
  useEffect(() => {
    // Initialize magnific popup or any gallery scripts
    // if (window.jQuery) {
    //   window.jQuery('.popup-image').magnificPopup({
    //     type: 'image',
    //     gallery: { enabled: true },
    //   });
    // }
  }, []);

  // Generate images 1-12
  const images = Array.from({ length: 12 }, (_, i) => i + 1);

  return (
    <section id="gallery-sec">
      <div className="gallery-area px-5">
        <div className="container th-container">
          <div className="title-area text-center">
            <span className="sub-title">Make Your Tour More Pleasure</span>
            <h2 className="sec-title">Recent Gallery</h2>
          </div>
          <div className="row gy-10 gx-10 justify-content-center align-items-center">
            {images.map((num) => (
              <div className="col-md-4 col-lg-2" key={num}>
                <div className="gallery-card">
                  <div className="box-img global-img">
                    <a href={`/assets/images/gallery/${num}.jpeg`} className="popup-image">
                      <div className="icon-btn"><i className="fal fa-magnifying-glass-plus"></i></div>
                      <img src={`/assets/images/gallery/${num}.jpeg`} alt="gallery" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;